import { render, staticRenderFns } from "./DriverDisplay.vue?vue&type=template&id=470ef612&"
import script from "./DriverDisplay.vue?vue&type=script&lang=js&"
export * from "./DriverDisplay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports